import API from '@/constants/api'
import ApiHelper from '@/utils/api-helper'

const getParams = (query) => {
  if (!query) {
    return {}
  }

  return (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce((params, param) => {
    const [key, value] = param.split('=')

    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : ''

    return params
  }, {})
}

export default {
  login(store, router, user, redirect) {
    const promise = ApiHelper.fetch(API.URL + API.LOGIN, {
      method: 'POST',
      body: JSON.stringify({
        user
      })
    })

    promise.then((data) => {
      this.saveUser(store, router, data.user, redirect)
    })

    return promise
  },

  updateToken(store, router, user) {
    this.saveUser(store, router, user)
  },

  checkAuth(store, router) {
    const jwt = this.getToken()

    let user = null

    if (!jwt) {
      /* eslint-disable prefer-promise-reject-errors */
      return Promise.reject('Anonymous user')
    }

    return ApiHelper.fetch(API.URL + API.USER, {
      method: 'GET'
    })
      .then((data) => {
        user = data.user
        localStorage.setItem('access_token', user.token)
        store.commit('SET_USER', { user })

        return store.dispatch('getProfile', { user })
      })
      .then(() => {
        if (
          !(user.isAdmin || user.isCompanyAdmin) &&
          !user.profileCompleted &&
          !(router.currentRoute.name === 'Profile' || router.currentRoute.name === 'Confirm')
        ) {
          router.push({
            name: 'Profile',
            query: { open: true, redirect: router.currentRoute.fullPath }
          })
        }

        return user
      })
      .catch((err) => {
        localStorage.removeItem('access_token')
        console.info(err)
      })
  },

  getToken() {
    if (typeof window === 'undefined') {
      return
    }

    const params = getParams(window.location.search)

    if (params.token) {
      localStorage.setItem('access_token', params.token)

      return params.token
    }

    return localStorage.getItem('access_token')
  },

  isLoggedIn() {
    if (typeof localStorage === 'undefined') {
      return true
    }

    return localStorage.getItem('access_token') !== null
  },

  saveUser(store, router, user, redirect) {
    localStorage.setItem('access_token', user.token)
    store.commit('SET_USER', { user: user })
    if (redirect) {
      this.loginRedirect(router, user, redirect)
    }
  },

  loginRedirect(router, user, redirect) {
    if (!(user.isAdmin || user.isCompanyAdmin) && !user.profileCompleted) {
      router.push({ name: 'Profile', query: { open: true, redirect } })

      return
    }

    if (redirect) {
      router.push({ path: redirect })
    } else if (user.isAdmin) {
      window.location = '/admin'
    } else if (user.isCompanyAdmin) {
      window.location = '/admin/opportunity'
    }
  },

  signUp(router, userData, redirect) {
    const promise = ApiHelper.fetch(API.URL + API.SIGN_UP, {
      method: 'POST',
      body: JSON.stringify({
        user: userData
      })
    })

    promise.then(() => {
      if (redirect) {
        router.push({ path: redirect })
      }
    })

    return promise
  },

  confirm(email, confirmationId) {
    return ApiHelper.fetch(API.URL + API.CONFIRM, {
      method: 'POST',
      body: JSON.stringify({
        email: email,
        confirmationId: confirmationId
      })
    })
  },

  reset(email) {
    return ApiHelper.fetch(API.URL + API.RESET, {
      method: 'POST',
      body: JSON.stringify({
        email: email
      })
    })
  },

  logout(store) {
    localStorage.removeItem('access_token')
    store.commit('SET_USER', { user: null })
  },

  changePassword(user) {
    return ApiHelper.fetch(`${API.URL + API.USER}`, {
      method: 'PUT',
      body: JSON.stringify({
        email: user.email,
        resetToken: user.token,
        user: {
          password: user.password
        }
      })
    })
  },

  deleteAccount(store, user) {
    return ApiHelper.fetch(`${API.URL + API.USER}/${user.email}`, {
      method: 'DELETE'
    }).then(() => {
      this.logout(store)
    })
  }
}
